module.exports = __webpack_public_path__ + "img/calendar-outline-black.a636d6f4.svg";